module.exports = __webpack_public_path__ + "0af5d249/img/at-icon.5d6fc5d8.svg";